import React from 'react';

export default function Home() {
  return (
    <div className='d-flex justify-content-center m5'>
      <h1>Welcome to Prept</h1>
    </div>
  );
}
